export default "__VITE_ASSET__DZQHxq$N__"